export default "__VITE_ASSET__d776052f__"